import React, { useState } from "react";

/**
 * Uzun kimlik (UUID) gösterimi.
 *
 * Varsayılan olarak ilk sekiz karakter görünür; ÜSTÜNE TIKLAYINCA tamamı açılır,
 * tekrar tıklayınca kapanır. Kimlikler tabloda ve detayda yan yana durduğu için
 * hepsini tam uzunlukta göstermek satırları okunmaz hale getiriyordu; tamamen
 * gizlemek ise kaydı takip edilemez yapardı.
 *
 * Açık hâlde satır kırılır (`break-all`): 36 karakterlik bir UUID dar kolonda
 * taşmak yerine alta sarar.
 */
const STYLE = `
  .id-value { cursor:pointer; }
  .id-value code { color:#221C5D; }
  .id-value.is-expanded code { word-break:break-all; }
`;

const IdValue = ({ value, className = "" }) => {
    const [expanded, setExpanded] = useState(false);

    if (!value) return <span className="text-muted">—</span>;

    const text = String(value);
    const short = text.length > 8 ? `${text.slice(0, 8)}…` : text;

    return (
        <span
            className={`id-value ${expanded ? "is-expanded" : ""} ${className}`}
            onClick={() => setExpanded((v) => !v)}
            title={expanded ? "Kısaltmak için tıklayın" : "Tamamını görmek için tıklayın"}
            role="button"
            tabIndex={0}
            onKeyDown={(e) => {
                if (e.key === "Enter" || e.key === " ") {
                    e.preventDefault();
                    setExpanded((v) => !v);
                }
            }}
        >
            <style>{STYLE}</style>
            <code>{expanded ? text : short}</code>
        </span>
    );
};

export default IdValue;
